/**
 * Super-admin ("webster-level") access.
 *
 * Several screens gate admin-only behaviour on the signed-in email: cross-PPJK
 * listings on Master pages, the full Master menu, the price columns in Database
 * Barang, and impersonation. Those checks used to be hardcoded to
 * webster@jar-vis.com one file at a time, so granting a second account meant
 * hunting them down. They all resolve through here now — add an email to
 * SUPER_ADMIN_EMAILS to grant the whole set.
 *
 * Matching is exact, deliberately. The impersonation check used to be a
 * substring test on "webster", which also matches webster@fr8cosystem.com,
 * webster.puninar@fr8cosystem.com and webster.weby@fr8cosystem.com — real
 * customer-domain accounts. Routing every surface through a substring would
 * have handed those three the Master menu, the cross-PPJK lists and the price
 * columns as a side effect. None of them has ever opened an impersonation
 * session, so exact matching costs nothing and keeps the grant deliberate.
 *
 * This is a UI gate only; the backend allowlist is IMPERSONATION_ALLOWED_EMAILS
 * on jvs-api. Keep the two in sync — this file scopes menus, that one enforces.
 */
const SUPER_ADMIN_EMAILS = new Set([
  'developer@apexintelligence.id',
  'admin@apexintelligence.id',
  'dhani@apexintelligence.id',
  'shan@apexintelligence.id',
]);

export function isSuperAdminEmail(email: string | undefined | null): boolean {
  if (!email) return false;

  return SUPER_ADMIN_EMAILS.has(email.trim().toLowerCase());
}

/** Reads the signed-in email from localStorage `authData`, '' when absent/unparseable. */
export function getCurrentUserEmail(): string {
  if (typeof window === 'undefined') return '';
  try {
    const raw = localStorage.getItem('authData');
    return raw ? String(JSON.parse(raw)?.email || '').toLowerCase() : '';
  } catch {
    return '';
  }
}

/** True when the signed-in account has super-admin access. */
export function isCurrentUserSuperAdmin(): boolean {
  return isSuperAdminEmail(getCurrentUserEmail());
}
